import { render, staticRenderFns } from "./PowerImitateView.vue?vue&type=template&id=795f2a4a&scoped=true"
import script from "./PowerImitateView.vue?vue&type=script&lang=js"
export * from "./PowerImitateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f2a4a",
  null
  
)

export default component.exports